import moment from 'moment'
/**
 * components util
 */

/**
 * Clean null values, object
 * @param children
 * @returns {*[]}
 */
export function filterEmpty(children = []) {
  return children.filter(c => c.tag || (c.text && c.text.trim() !== ''))
}

/**
 * Get string length, English characters Length1, English character length2
 * @param {*} str
 */
export const getStrFullLength = (str = '') =>
  str.split('').reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0)
    if (charCode >= 0 && charCode <= 128) {
      return pre + 1
    }
    return pre + 2
  }, 0)

/**
 * Truncate string, based on maxLength Truncate and return
 * @param {*} str
 * @param {*} maxLength
 */
export const cutStrByFullLength = (str = '', maxLength) => {
  let showLength = 0
  return str.split('').reduce((pre, cur) => {
    const charCode = cur.charCodeAt(0)
    if (charCode >= 0 && charCode <= 128) {
      showLength += 1
    } else {
      showLength += 2
    }
    if (showLength <= maxLength) {
      return pre + cur
    }
    return pre
  }, '')
}
export function transformTime(time, flag) {
  if (flag == 1) {
    return moment(time).format('DD-MM-YYYY')
  }else if (flag == 2) {
    return moment(time).format('DD-MM-YYYY HH:mm:ss')
  }else if (flag == 3) {
    return moment(time).format('DD-MM-YYYY HH:mm')
  }
  return moment(time).format('YYYY-MM-DD')
}